import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@astral/ui';
import { useT } from '../providers/I18nProvider.js';

/** Compact subpage header with an explicit Back-to-Home control (no bottom nav). */
export function SubHeader({ title, trailing }: { title: string; trailing?: ReactNode }): JSX.Element {
  const navigate = useNavigate();
  const t = useT();
  return (
    <div className="subhead">
      <button className="subhead__back" aria-label={t('common.back')} onClick={() => navigate('/')}>
        <Icon name="arrow-left" size={20} />
      </button>
      <span className="subhead__title">{title}</span>
      {trailing}
    </div>
  );
}
